<template>
	<div class="app-item menu-group">
		<van-icon name="more" />
		<div @click='$router.push(`/m/${item.id}`)'>
			<van-image :src='item.icon'></van-image>
			<div class="text">{{item.name}}</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ["item"],
		data() {
			return {
				user: this.$config.userinfo,
			};
		},
	};
</script>
<style lang="less">
.menu-group {
	position: relative;
	.van-icon {
		position: absolute;
		top: 2px;
		right: 2px;
		color: #d2931e;
	}
}
</style>